import { Grid as Grid$1 } from '@mui/material';

const Grid = Grid$1;

export { Grid };
